import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import StepHeader from "../../../Trips/TripDetails/components/StepHeader";
import TripSearch from "./TripSearch";
import TripList from "./TripList";
import HubAssignmentForm from "./HubAssignmentForm";
import { client } from "../../../../Utils/axiosClient";

const TripAssignment = ({
  mode,
  setStep,
  deliveryPrice: propDeliveryPrice,
  setDeliveryPrice: propSetDeliveryPrice,
  selectedTrip: propSelectedTrip,
  setSelectedTrip: propSetSelectedTrip,
}) => {
  const isAgentMode = mode === "agent";
  const { currentRequest } = useSelector((state) => state.requests);

  const [tripsData, setTripsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [localSelectedTrip, setLocalSelectedTrip] = useState(null);
  const [search, setSearch] = useState("");
  const [localDeliveryPrice, setLocalDeliveryPrice] = useState("");

  const hubId =
    currentRequest?.hubId ||
    currentRequest?.metaData?.hubId ||
    currentRequest?.metaData?.hub_id;

  const collectionPointId =
    currentRequest?.collectionPointId ||
    currentRequest?.metaData?.collectionPointId ||
    currentRequest?.metaData?.collection_point_id;

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        setLoading(true);

        const now = dayjs().startOf("day").format("YYYY-MM-DD");
        const threeDaysLater = dayjs()
          .add(3, "day")
          .endOf("day")
          .format("YYYY-MM-DD");

        const params = {
          limit: 50,
          offset: 0,
          startDate: now,
          endDate: threeDaysLater,
          status: [2],
        };

        const targetHubs = [collectionPointId].filter(Boolean);

        if (targetHubs.length) {
          params.locationHubs = targetHubs;
        }

        if (hubId) {
          params.hubId = [hubId];
        }

        if (search) {
          params.searchQuery = search;
        }

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/trip/get-trips`,
          { params },
        );

        if (response.data?.result && Array.isArray(response.data.result)) {
          const formatted = response.data.result.map((t) => ({
            id: String(t.id),
            date: t.startTime || t.startDate || t.createdAt,
            schedule:
              t.startTime || t.startDate
                ? `${dayjs(t.startTime || t.startDate).format("MMM DD")}, ${
                    t.timeSlot || ""
                  }`
                : `Trip #${t.id}`,
            hubName: t.hubName || t.hub_name || "",
            route: t.routeName || t.route_name || "",
            stops: t.stops || [],
          }));

          setTripsData(formatted);
        } else {
          setTripsData([]);
        }
      } catch (err) {
        setTripsData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrips();
  }, [currentRequest, hubId, collectionPointId, search]);

  const selectedTrip =
    propSelectedTrip !== undefined ? propSelectedTrip : localSelectedTrip;
  const setSelectedTrip = propSetSelectedTrip || setLocalSelectedTrip;

  const deliveryPrice =
    propDeliveryPrice !== undefined ? propDeliveryPrice : localDeliveryPrice;
  const setDeliveryPrice = propSetDeliveryPrice || setLocalDeliveryPrice;

  return (
    <>
      <StepHeader
        title={
          isAgentMode
            ? "Select a trip and set a price"
            : "Set pickup date & time"
        }
        onBack={() => setStep(2)}
      />

      {isAgentMode ? (
        <>
          <p className="font-aileron font-semibold text-sm text-dark-gray my-4">
            List of upcoming trips on the farmer&apos;s route (Next 3 Days)
          </p>

          <TripSearch search={search} setSearch={setSearch} />

          {loading ? (
            <div className="py-6 text-center">
              <p className="font-aileron text-xs text-dark-gray">
                Loading trips...
              </p>
            </div>
          ) : (
            <TripList
              trips={tripsData}
              selectedTrip={selectedTrip}
              onTripSelect={setSelectedTrip}
            />
          )}

          <div className="mt-6">
            <p className="mb-1.5 text-xs font-normal text-dark-gray">
              Delivery Price
            </p>

            <div className="flex items-center gap-3">
              <input
                value={deliveryPrice}
                onChange={(e) => setDeliveryPrice(e.target.value)}
                placeholder="Enter Amount"
                className="h-8 w-[256px] rounded-md border border-light-grey px-3.5 text-xs"
              />

              <span className="font-semibold text-xs">Ksh</span>
            </div>
          </div>
        </>
      ) : (
        <HubAssignmentForm
          deliveryPrice={deliveryPrice}
          setDeliveryPrice={setDeliveryPrice}
        />
      )}
    </>
  );
};

export default TripAssignment;
